import React from 'react';
import './GradeFilter.css';

export const GRADE_OPTIONS = [
    { value: '10', label: '10' },
    { value: '9', label: '9' },
    { value: '8', label: '8' },
    { value: '7', label: '7+' },
];

// Faithful to Binder's grade matching: '7' means grade <= 7, the rest are a
// substring match on the cert's grade string. Empty selection = show all.
export const filterByGrade = (listings, selectedGrades) => {
    if (!selectedGrades || selectedGrades.length === 0) return listings;
    return listings.filter((listing) => {
        const grade = listing.cert?.grade;
        if (!grade) return false;
        return selectedGrades.some((g) => {
            if (g === '7') {
                const m = String(grade).match(/\d+/);
                if (!m) return false;
                const n = parseInt(m[0], 10);
                return !Number.isNaN(n) && n <= 7;
            }
            return String(grade).includes(g);
        });
    });
};

// Segmented pill filter (PSA 10 / 9 / 8 / 7+), multi-select toggle.
const GradeFilter = ({ selected, onToggle }) => (
    <div className="gh-grades" role="group" aria-label="Filter by PSA grade">
        <span className="gh-grades-label">PSA</span>
        {GRADE_OPTIONS.map((o) => {
            const on = selected.includes(o.value);
            return (
                <button
                    key={o.value}
                    type="button"
                    className={`gh-grade ${on ? 'active' : ''}`}
                    aria-pressed={on}
                    onClick={() => onToggle(o.value)}
                >
                    {o.label}
                </button>
            );
        })}
    </div>
);

export default GradeFilter;
